import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex flex-column ms-4 mt-2" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", null, "        " + "\n    ", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-3 g-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "body-image w-100px h-100px" }
const _hoisted_9 = { class: "body-content d-flex flex-column justify-content-center align-items-center px-8" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "card-text" }
const _hoisted_13 = { class: "text-body-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_avatar, {
        size: 'large',
        src: ''
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.idteam), 1),
        _createElementVNode("h6", null, "Registrados: " + _toDisplayString(_ctx.listNominal.length), 1)
      ])
    ]),
    _hoisted_4,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listNominal, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col"
          }, [
            _createVNode(_component_router_link, {
              to: `#`,
              class: "card mb-4 shadow text-black border border-2 border-primary border-hover text-center",
              style: {"max-width":"540px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_avatar, {
                      fit: 'contain',
                      class: "img-fluid w-100 h-100 bg-white border",
                      shape: "circle",
                      src: `https://sismaster.perufedup.com/writable/uploads/${item.photo}`
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h5", _hoisted_10, [
                      _createTextVNode(_toDisplayString(item.firstname), 1),
                      _hoisted_11,
                      _createTextVNode(" (" + _toDisplayString(item.lastname) + " " + _toDisplayString(item.surname) + ")", 1)
                    ]),
                    _createElementVNode("p", _hoisted_12, [
                      _createElementVNode("small", _hoisted_13, "(" + _toDisplayString(item.function_name) + ")", 1)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}